module.exports = __webpack_public_path__ + "img/4.1087312a.jpg";